import { authFetch, hasActiveAuthSession } from './auth-api';

export interface Product {
  id: string;
  name: string;
  description: string;
  kind: 'subscription' | 'topup';
  billingPeriod: 'none' | 'month' | 'quarter' | 'year';
  priceFen: string;
  credits: string;
  durationDays: number | null;
  planRank: number;
  tier: string;
  features: string[];
}

export interface Catalog {
  products: Product[];
  paymentProviders: { alipay: boolean; wechat: boolean };
}

export interface BillingAccount {
  balance: string;
  debtCredits: string;
  lifetimeCredited: string;
  lifetimeDebited: string;
  subscription: { product_id: string; period_end: string } | null;
  freeActivated: boolean;
}

const API_BASE = String(import.meta.env.VITE_PAYMENT_API_BASE || '/payment-api').replace(/\/$/, '');

async function request<T>(path: string, init?: RequestInit): Promise<T> {
  const headers = new Headers(init?.headers);
  if (init?.body) headers.set('Content-Type', 'application/json');
  const response = await authFetch(`${API_BASE}${path}`, { ...init, headers });
  const payload = await response.json().catch(() => ({}));
  if (!response.ok) throw new Error(payload?.error?.message || '请求失败，请稍后重试');
  return payload as T;
}

export const hasLogin = hasActiveAuthSession;
export const getCatalog = async () => {
  const catalog = await request<Catalog>('/v1/catalog');
  if (!Array.isArray(catalog.products) || !catalog.paymentProviders) throw new Error('套餐服务暂时不可用');
  return catalog;
};
export const getAccount = () => request<BillingAccount>('/v1/billing/account');
export const getTeamAccount = (teamId: string) => request<BillingAccount>(`/v1/teams/${encodeURIComponent(teamId)}/billing/account`);
export const activateFree = () => request<{ activated: boolean }>('/v1/free/activate', { method: 'POST' });
export const createOrder = (productId: string, provider: 'alipay' | 'wechat', teamId?: string) => request<{
  order: { id: string };
  checkout: { type: 'redirect' | 'qr_code'; value: string };
}>('/v1/checkout/orders', { method: 'POST', body: JSON.stringify({ productId, provider, teamId: teamId || undefined }) });
export const getOrder = (id: string) => request<{ status: string }>(`/v1/orders/${id}`);
